import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {Kontakt} from '../models/kontakt.model';
import { HttpClient } from '@angular/common/http';
import * as fileSaver from 'file-saver';
import {KontakteImportResult} from '../models/kontakteImportResult.model.cs';


@Injectable()
export class KontakteDataService {
    baseUrl: string = environment.apiUrl;

    constructor(private http: HttpClient) {
    }

    public getKontakte(): Observable<Kontakt[]> {
        const query = `${this.baseUrl}/kontakte`;
        return this.http.get<Kontakt[]>(query);
    }

    public refreshKontakt(abacusClientId: number) {
        const query = `${this.baseUrl}/kontakte/abacus/${abacusClientId}`;
        return this.http.patch<Kontakt>(query, {});
    }

    public getKontakt(id: number): Observable<Kontakt> {
        const query = `${this.baseUrl}/kontakte/${id}`;
        return this.http.get<Kontakt>(query);
    }

    public getAbacusKontakt(abacusClientId: number): Observable<Kontakt> {
        const query = `${this.baseUrl}/kontakte/abacus/${abacusClientId}`;
        return this.http.get<Kontakt>(query);
    }

    public createKontaktFromAbacusId(abacusClientId: number): Observable<Kontakt> {
        const query = `${this.baseUrl}/kontakte/abacus`;
        return this.http.post<Kontakt>(query, abacusClientId);
    }

    public createKontakt(kontakt: Kontakt): Observable<Kontakt> {
        const query = `${this.baseUrl}/kontakte`;
        return this.http.post<Kontakt>(query, kontakt);
    }

    public updateKontakt(id: number, kontaktToUpdate: Kontakt) {
        const query = `${this.baseUrl}/kontakte/${id}`;
        return this.http.put(query, kontaktToUpdate);
    }

    public deleteKontakt(id: number) {
        const query = `${this.baseUrl}/kontakte/${id}`;
        return this.http.delete<Kontakt>(query);
    }

    public patchKontakt(id: number, patchOp: any): Observable<Kontakt> {
        const query = `${this.baseUrl}/kontakte/${id}`;
        return this.http.patch<Kontakt>(query, patchOp);
    }

    public csvExport(ids: number[], filename: string = 'kontakte_export.csv') {
        this.http.post(`${this.baseUrl}/kontakte/csv`, ids, {responseType: 'blob'})
            .subscribe(blob => fileSaver.saveAs(blob, filename));
    }

    public csvImport(file: File): Observable<KontakteImportResult> {
        const query = `${this.baseUrl}/kontakte/csv-import`;
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post<KontakteImportResult>(query, formData);
    }

    downloadExample() {
        this.http.get(`${this.baseUrl}/kontakte/csv-import/example`, {responseType: 'blob'})
            .subscribe(blob => fileSaver.saveAs(blob, 'kontakte_import.csv'));
    }
}
